function AssigneTask() {
  return <>assigne task</>;
}

export default AssigneTask;
